module.exports = __webpack_public_path__ + "img/undraw_Memory_storage_reh0.bbd85e13.svg";